/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {firstValueFrom, tap} from 'rxjs';

import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';
import {SignalAdminResourceContextActionsComponent} from '../../common/controller/signal-admin-resource-context-actions.component';
import {SignalAdminResourcePageState} from '../../common/controller/signal-admin-resource-page-state';
import {SignalAdminResourceTitleComponent} from '../../common/controller/signal-admin-resource-title.component';
import {ListDefaultActionsComponent} from '../../common/directives/list-default-actions.component';
import {stateTitleView} from '../../common/directives/html/state-title.component';
import {StateDeclarationBuilder, AdnRouterHelperApi} from '../../routing/state-utils';
import {CouponApiService, CouponModel} from './coupon-api.service';
import {CouponCopyModalComponent} from './coupon-copy-modal.component';
import {CouponEditPageComponent} from './coupon-edit-page.component';
import {CouponRoutePageComponent} from './coupon-route-page.component';

export function couponStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const states = new StateDeclarationBuilder();
  const api = adnRouterHelper.services.service(CouponApiService);
  const userProfileSaver = adnRouterHelper.services.service(UserProfileSaverService);
  const rh = adnRouterHelper.createRouterHelper('coupons.coupon', CouponApiService, 'app.adm', 'app/admin');
  const copyConfig = {
    modalComponent: CouponCopyModalComponent,
    stateUrl: 'app.adm.coupons.coupon',
    lcase: 'coupon',
    ucase: 'Coupon'
  };

  states.add(rh.listPath(), rh.list({
    views: {
      'content@app': {component: CouponRoutePageComponent, bindings: {readOnly: 'listReadOnly'}},
      'context@app': {component: ListDefaultActionsComponent, bindings: {readOnly: 'listReadOnly', newStateName: 'listNewStateName'}},
      'title@app': stateTitleView()
    }
  }));
  states.add(rh.newItemPath(), rh.newItem());
  states.add(rh.itemPath(), rh.item({
    resolve: {
      couponPage: function($stateParams: any, readOnly: boolean) {
        if ($stateParams.isNew) {
          const model: CouponModel = {id: $stateParams.id, objectState: 'ACTIVE', validationWarnings: []};
          return new SignalAdminResourcePageState(model, true, readOnly, api, 'Coupon', 'name', copyConfig);
        }
        return firstValueFrom(api.get($stateParams.id).pipe(
          tap((model) => userProfileSaver.saveObj(model, 'adnLastViewed'))
        )).then((model) => new SignalAdminResourcePageState(model, false, readOnly, api, 'Coupon', 'name', copyConfig));
      },
      model: function(couponPage: SignalAdminResourcePageState<CouponModel>) {
        return couponPage.model();
      }
    },
    views: {
      'content@app': {component: CouponEditPageComponent, bindings: {state: 'couponPage'}},
      'context@app': {component: SignalAdminResourceContextActionsComponent, bindings: {state: 'couponPage'}},
      'title@app': {component: SignalAdminResourceTitleComponent, bindings: {state: 'couponPage'}}
    }
  }));
  return states.build();
}
